// extracted by mini-css-extract-plugin
export default {"chars-item":"allcharacter-item_chars-item__BOL3J","summary":"allcharacter-item_summary__f2-8w","image":"allcharacter-item_image__jSzpv","descr":"allcharacter-item_descr__Aau08"};